import { Network } from "@/network";
import { TCBReceiptApi } from "@/network/pb/proto";
import { Log } from "@/util";

// const cgjsCrypt = require('@/assets/js/CGJSCrypt_min.js');
export class E2eeModel {

    // private static sInstance: E2eeModel;

    // public static get instance(): E2eeModel {
    //     if (!E2eeModel.sInstance) {
    //         E2eeModel.sInstance = new E2eeModel();
    //     }

    //     return E2eeModel.sInstance;
    // }
    
    // private e2eeResponse = TCBReceiptApi.Protobuf.E2eeResponse.create();
    // public async getEtoeePd(originPd:string): Promise<any> {
    //     let crypted2 = '';/*E2EE:JS密文*/
    //     /* E2EE 1.取得公鑰與時間*/
    //     await Network.sendAPI(
    //         "/api/e2ee/GetTimeAndKey",
    //         "get"
    //     )
    //         .then((rawResponse) => {
    //             const response = TCBReceiptApi.Protobuf.Response.decode(
    //                 new Uint8Array(rawResponse.data as ArrayBufferLike)
    //             );
    //             this.e2eeResponse = TCBReceiptApi.Protobuf.E2eeResponse.decode(
    //                 new Uint8Array(response.item)
    //             );
    //             /* E2EE 2.JS加密*/
    //             const publicKey = this.e2eeResponse.pubKey;/*E2EE:系統時間*/
    //             const timestamp = this.e2eeResponse.serverTime;/*E2EE:系統時間*/
    //             try {
    //                 if (timestamp.length > 0)
    //                     crypted2 = this.CertEncryptTimeStamp(publicKey, originPd, timestamp, '0');
    //                 else
    //                     crypted2 = this.CertEncryptTimeStamp(publicKey, originPd, '0', '0');
    //             } catch (e) {
    //                 console.error('Encryption error:', e);
    //             }
    //         })
    //         .catch((error) => {
    //             Log.error(error);
    //         })
    //         .finally(()=>{
    //             return crypted2;
    //         });
    // }
    // public CertEncryptTimeStamp(public_key:string, input:string, sRSATime:string, iflags:string) {
    //     var rsatimePattern = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})Z$/;
    //     if (typeof(sRSATime) === 'string') {
    //         if (!rsatimePattern.test(sRSATime))
    //             throw "Invalid timestamp format"; 
    //     } else {
    //         iflags = sRSATime;
    //         var date = new Date();
    //         if (date.toISOString) {
    //             // IE9 and above
    //             var isostrPattern = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})\.(\d{3})Z$/;
    //             sRSATime = date.toISOString().replace(isostrPattern, "$1-$2-$3 $4:$5:$6Z"); // format: "YYYY-MM-DD HH:mm:ssZ"
    //         } else {
    //             sRSATime = date.getUTCFullYear().toString();
    //             sRSATime += "-";
    //             sRSATime += ("0" + (date.getUTCMonth() + 1)).slice(-2);
    //             sRSATime += "-";
    //             sRSATime += ("0" + date.getUTCDate()).slice(-2);
    //             sRSATime += " ";
    //             sRSATime += ("0" + date.getUTCHours()).slice(-2);
    //             sRSATime += ":";
    //             sRSATime += ("0" + date.getUTCMinutes()).slice(-2);
    //             sRSATime += ":";
    //             sRSATime += ("0" + date.getUTCSeconds()).slice(-2);
    //             sRSATime += "Z";
    //         }
    //     }
    //     return cgjsCrypt.CertEncrypt(public_key, input + sRSATime, iflags);
    // }
}

// const e2eeModel = E2eeModel.instance;

// export { e2eeModel as E2eeModel };